import Elemento from "./Elemento.js";

export default class Campo extends Elemento {
  constructor() {
    super();
    this.acabados = new Array();
    this.acabadoSel;
    this.filtroSel = {
      Live: {},
      Delay: {},
    };
    this.visual;
    this.esCapa;
    this.value;
    this.tipo; // "input" "dropdown" "tacos"
    this.visible;
    this.condicion;
    this.ayuda;
    this.relacion;
    this.compuesto;
    this.medida;
    this.error = false;
    this.precios = [];

    this.GetAcabado = function (cod) {
      return this.acabados.filter((acabado) => acabado.cod == cod)[0];
    };
    this.GetFiltro = function (cod) {
      return this.filtros.filter((filtro) => filtro.cod == cod)[0];
    };

    this.GetAcabadosValidos = function (perfil) {
      var acabados = [];

      this.acabados.forEach((acabado) => {
        if (acabado.condicion == "" || acabado.condicion == undefined) {
          acabados.push(acabado);
        } else {
          const resultado = eval(acabado.condicion); // Se evalua contra perfil
          if (resultado) {
            acabados.push(acabado);
          }
        }
      });
      return acabados;
    };

    this.EsError = function (perfil) {
      var status = false;

      if (this.tipo == "input") {
        if (this.medida != undefined) {
          if (
            Number(this.value) < this.medida.minimo ||
            Number(this.value) > this.medida.maximo
          ) {
            status = true;
          }
        }
      } else if (
        this.tipo == "dropdown" ||
        this.tipo == "tacos" ||
        this.tipo == "toggle"
      ) {
        if (
          this.acabadoSel.condicion != undefined &&
          this.acabadoSel.condicion != ""
        ) {
          try {
            status = !eval(this.acabadoSel.condicion);
          } catch (error) {
            //console.log(this.cod);
            //console.log("Error", error);
            //console.log("Condicion", this.acabadoSel.condicion);
            //console.log("Perfil", perfil);
          }
        }
      }

      return status;
    };
  }
}
